/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {TemporaryMcpCreateChartRequest} from '@cash-web/protos/squareup/cash/activity/api/v1/charting.pb'
import {TemporaryMcpCreateChartResponse} from '@cash-web/protos/squareup/cash/activity/api/v1/charting.pb'


export const temporaryMcpCreateChart = (request: TemporaryMcpCreateChartRequest, options?: CashRequestOptions) => post<TemporaryMcpCreateChartRequest, TemporaryMcpCreateChartResponse>("/2.0/cash/temporary-mcp-create-chart", request, {...options, rejectOnError: true })